'use client';

import React from 'react';

import { Button } from '@/components/ui/button';

type T_CommunityItemProps = {
  icon: React.ReactNode;
  name?: string;
  url?: string;
};

function CommunityItem({ icon, name, url }: T_CommunityItemProps) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="max-md:flex max-md:flex-1"
    >
      <Button
        variant="outline"
        icon={icon}
        className="h-9 px-3 py-2 w-18 max-md:w-full"
        title={name}
      ></Button>
    </a>
  );
}

export default CommunityItem;
